export default {
  header: {
    notes: 'Header for recommendation details',
    message: 'Details',
  },
  publish: {
    button: {
      notes: 'Title for Publish button',
      message: 'Publish',
    },
    dialogText: {
      notes: 'Content for Publish dialog',
      message:
        'Are you sure you want to publish the recommendation {{topic}}, assigned to {{assignee}} at {{company}}?',
    },
    success: {
      notes: 'Publish success toast message',
      message: 'The recommendation {{topic}} has been successfully published',
    },
  },
  generalInformation: {
    notes: 'Header for General information accordion',
    message: 'General information',
  },
  summary: {
    notes: 'Summary sub header in recommendation details',
    message: 'Summary',
  },
  items: {
    notes: 'Items sub header in recommendation details',
    message: 'Items',
  },
};
